import styled from 'styled-components';

import { Text2 } from '@components/styles/Typography';

const ProductFeature = ({ title, feature, testId }) => (
    <FeatureWrapper data-testid={testId}>
        <Text2 color="bgGray25">{title}</Text2>
        <Text2>{feature}</Text2>
    </FeatureWrapper>
);
const FeatureWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;

    p {
        padding-bottom: 15px;

        :first-child {
            text-align: left;
            white-space: nowrap;
            min-width: 92px;
        }
        :last-child {
            margin-left: 20px;
            text-align: start;
        }
    }
`;
export default ProductFeature;
